"use client"
import type { UserInfo, UserLocation } from '@/types'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
const STORAGE_KEY = "user-info-storage";
const initialState = {
    userInfo: {
        accountType: 0,
        cookie: '',
        email: '',
        emailVerified: false,
        freshuser: false,
        idToken: '',
        jwt_token: '',
        Authorization: '',
        nbid: '',
        nbid_not_exist: false,
        nickname: '',
        profile_id: '',
        profile_url: '',
        registered: false,
        userid: 0,
        username: '',
        usertype: '',
        version: '',
    } as UserInfo,
    userLocation: {
        zip: '',
        postalCode: '',
        locality: '',
        adminArea: '',
        displayName: '',
    } as UserLocation,
}

type UserInfoType = {
    userInfo: UserInfo;
    userLocation: UserLocation;
    loading: boolean;
    isLogin: boolean;
    setUserInfo: (userInfo: UserInfo) => void;
    setUserLocation: (userLocation: UserLocation) => void;
    clearUserLocation: () => void;
    logOut: () => void;
    setLoading: (loading: boolean) => void;
    setIsLogin: (isLogin: boolean) => void;
}

export const useUserInfoStore = create<UserInfoType>()(
    persist(
        (set) => ({
            userLocation: {
                ...initialState.userLocation,
            },
            userInfo: {
                ...initialState.userInfo,
            },
            loading: false,
            isLogin: false,
            setUserInfo: (userInfo: UserInfo) => set({ userInfo: { ...userInfo } }),
            setUserLocation: (userLocation: UserLocation) => set({ userLocation: { ...userLocation } }),
            clearUserLocation: () => set({ userLocation: { ...initialState.userLocation } }),
            logOut: () => set({ userInfo: { ...initialState.userInfo }, userLocation: { ...initialState.userLocation }, loading: false, isLogin: false }),
            setLoading: (loading: boolean) => set({ loading }),
            setIsLogin: (isLogin: boolean) => set({ isLogin }),
        }),
        {
            name: STORAGE_KEY,
            partialize: (state) => ({
                userInfo: state.userInfo,
                userLocation: state.userLocation,
                isLogin: state.isLogin,
            }),
        }
    )
)
